<ngx-file-drop (onFileDrop)="onFileDrop($event)">
    <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
        <div style="margin-top: -68px;"> drop json here</div>

    </ng-template>
</ngx-file-drop>